module.exports = __webpack_public_path__ + "static/media/about-skill-logos.e8ce3d3c.png";